const roundNumber = (number: number) => {
    return Math.round(number * 100) / 100;
};

export default roundNumber;
